import { render } from "./SignUpCarousel.vue?vue&type=template&id=4c834580&scoped=true"
import script from "./SignUpCarousel.vue?vue&type=script&lang=js"
export * from "./SignUpCarousel.vue?vue&type=script&lang=js"

import "./SignUpCarousel.vue?vue&type=style&index=0&id=4c834580&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c834580"]])

export default __exports__